import { createSelector } from "reselect"
import { pickBy, find, isEmpty, map } from "lodash"
import { getAllItems, getOrderedCategoryItems, getDisplayType } from "./items"
import { getFavoriteFactors } from "modules/portfolio-root/selectors/portfolios"
import { getFilteredFactorSensitivity, getFirst, getCurrent } from "./sensitivity"
import { computeCategoryItemsSubset, computeDisplayCategories, computeNonZerosKeys, computeOptions } from "helpers/analyze"
import { getAllResourcesStatuses } from "selectors/data"
import { getCategories } from "selectors/factors"
import { isLoading, combineResourcesStatuses } from "helpers/data-statuses"
import { computeFactorSensitivityData } from "helpers/factorSensitivity"

const EMPTY_ARRAY = []

const getData = createSelector(
  [getAllItems, getFilteredFactorSensitivity],
  computeFactorSensitivityData,
)

const getNonZerosKeys = createSelector(
  [getData, getFavoriteFactors],
  computeNonZerosKeys,
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItemsSubset,
)

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys, getCategoryItemsSubset],
  (data, keys, items) => isEmpty(items) ? EMPTY_ARRAY : map(data, item => pickBy(item, (_, key) => keys[key])),
)

const getDisplayCategories = createSelector(
  [getAllItems, getNonZerosKeys],
  computeDisplayCategories,
)

export const getOptions = createSelector(
  [getCategories, getFirst, getCurrent, getDisplayCategories],
  computeOptions,
)

export const getSelectedOption = createSelector(
  [getOptions, getDisplayType],
  (options, displayType) => find(options, { id: displayType }),
)

export const getPassthroughResourcesStatus = createSelector(
  [getAllResourcesStatuses],
  (statuses) => combineResourcesStatuses("factorSensitivity", statuses),
)

export const getIsLoading = createSelector(
  [getPassthroughResourcesStatus],
  isLoading,
)
